function Shopping() {
  // class="bg-paper h-48 w-64"
  return (
    <>
      <div className=" text-3xl max-w-screen-xl mx-auto flex justify-center items-center bg-paper min-h-full py-96 font-extrabold">
        🛠서비스 준비 중⚙
      </div>
    </>
  );
}
export default Shopping;
